export const FEMALE = 1
export const MALE = 2

export const GenderEnum = [
  { value: FEMALE, label: 'Female' },
  { value: MALE, label: 'Male' }
]
